import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, dateFilter, Comparator, customFilter } from 'react-bootstrap-table2-filter';
import { Type } from 'react-bootstrap-table2-editor';
import { Slide, Container, createMuiTheme, Dialog, Toolbar, Typography, Fab, CssBaseline, Grid, AppBar } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from "@material-ui/core/styles";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'date-fns';
import moment from 'moment';
import styles from "../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext';
import { Context } from "../contexts/siteContext";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveJournalOfflineData } from "../../offline/dataService/journalOfflineData";
import { ConvertToCurrentTimeZone, ConvertTimeToUTC } from '../header/timeFormatter';
import { TransactionTime } from '../common/transactionTime';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import JournalAdd from '../journal/journalAdd';
import ConfirmDialog from '../common/confirmDialog';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { blackColor } from '../../jss/material-dashboard-react.js';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function JournalList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(true);
    const [journalEditOpen, setJournalEditOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [date, setDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite));
    const [id, setId] = useState();
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [journals, setJournals] = useState([]);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const SiteId = defaultSite.id;

    const rowStyle = (row, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const addJournal = () => {
        setRecordToBeEdit([]);
        setJournalEditOpen(true);
    };

    const editJournal = (row) => {
        setRecordToBeEdit(row);
        setJournalEditOpen(true);
    };

    const closeJournalEdit = () => {
        TransactionTime.cancel();
        setJournalEditOpen(false);
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = journals;
            const index = data.findIndex(x => x.AppJournalId === item.AppJournalId);
            if (index === -1)
                data.push(item);
            else
                data[index] = item;
            setJournals(data);
        }
    };

    const deleteJournalConfirm = (journalId) => {
        setConfirmOpen(true);
        setId(journalId);
    };

    const deleteJournal = () => {
        setConfirmOpen(false);

        if ((id + "").substr(0, 1) === "$") {
            const data = journals.filter(item => item.AppJournalId !== id);
            setJournals(data);
            SaveJournalOfflineData(defaultSite.id, id, "SaveJournal", { AppJournalId: id }, "/Journal/DeleteJournal", false, true);
        }
        else {
            HttpService.post('/Journal/DeleteJournal', { AppJournalId: id })
                .then(async result => {
                    if (result && result.offline) {
                        await SaveJournalOfflineData(defaultSite.id, id, "DeleteJournal", { AppJournalId: id }, "/Journal/DeleteJournal", false, true);
                    }
                    else {
                        await SaveJournalOfflineData(defaultSite.id, id, "DeleteJournal", { AppJournalId: id }, "/Journal/DeleteJournal", true, true);
                    }
                    const data = journals.filter(item => item.AppJournalId !== id);
                    setJournals(data);
                },
                    (error) => {
                        console.log(error);
                    }
                );
        }
    };

    const getJournals = () => {
        setBackDrop(true);
        HttpService.post('/Journal/GetJournals', {
            SiteId: SiteId,
            WhoCalled: null,
            ExcludeCompleted: false,
            JournalDate: date
        })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "JournalDetails");
                    let items = [];

                    for (let item of offlineResult.OfflineData.data) {
                        if (item.Time.indexOf(moment(date).format("MM/DD/YYYY")) !== -1)
                            items.push(item);
                    }
                    setJournals(items);
                    setBackDrop(false);
                }
                else {
                    setJournals(result.data);
                    setBackDrop(false);
                }
            },
                (error) => {
                    console.log(error);
                });
    };

    const saveJournal = (journal) => {
        journal.ModifiedDateTime = ConvertTimeToUTC(new Date());
        setBackDrop(true);
        HttpService.post('/Journal/SaveJournal', journal)
            .then(async result => {
                setBackDrop(false);
                if (result && result.offline) {
                    let indexedDBId = await SaveJournalOfflineData(defaultSite.id, journal.AppJournalId, "SaveJournal", journal, "/Journal/SaveJournal", false, false);
                    if (journal.AppJournalId === 0)
                        journal.AppJournalId = "$" + indexedDBId;
                    updateList(journal);

                }
                else {
                    await SaveJournalOfflineData(defaultSite.id, journal.AppJournalId, "SaveJournal", result.data, "/Journal/SaveJournal", true, false);
                    updateList(result.data);
                }
            },
                (error) => {
                    console.log(error);
                }
            );
    };

    useEffect(() => {
        getJournals();
        // eslint-disable-next-line 
    }, [date]);

    const fetchData = () => {

        const columns = [
            {
                dataField: 'AppJournalId',
                text: 'ID',
                hidden: true
            },
            {
                dataField: "rowNumber",
                text: '#',
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground,
                    width: '35px'
                },
                style: {
                    color: currentTheme.text
                },
                formatter: (cellContent, row, index) => { return (<div>{index + 1}</div>); }
            },
            {
                dataField: 'WhoCalled',
                text: 'Who Called',
                sort: true,
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                },
                style: {
                    color: currentTheme.text
                },
                filter: textFilter({ style: { color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground } }),
                validator: (newValue, row, column) => {
                    if (newValue === "") {
                        return {
                            valid: false,
                            message: 'Who called is required.'
                        };
                    }
                    return true;
                }
            },
            {
                dataField: 'Time',
                text: 'Date',
                editor: { type: Type.DATE },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                },
                filter: dateFilter({
                    defaultValue: { date: new Date() },
                    withoutEmptyComparatorOption: false,
                    comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
                    onFilter: item => {
                        setDate(new Date(item.date).toLocaleDateString("en-US"));
                    },
                    dateStyle: { color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground }
                })
            },
            {
                dataField: 'Completed',
                text: 'Completed',
                //editable: false,
                editor: {
                    type: Type.CHECKBOX,
                    value: true
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                },
                style: {
                    color: currentTheme.text
                },
                formatter: (cellContent, row, column) => (row.Completed === true ? <CheckBoxIcon
                    onClick={() => {
                        const data = journals;
                        const index = data.findIndex(x => x.AppJournalId === row.AppJournalId);
                        if (index !== -1) {
                            row.Completed = false;
                            saveJournal(row);
                        }
                    }}
                /> : <CheckBoxOutlineBlankIcon onClick={() => {
                    const data = journals;

                    const index = data.findIndex(x => x.AppJournalId === row.AppJournalId);
                    if (index !== -1) {
                        row.Completed = true;
                        saveJournal(row);
                    }

                }} />),
                filter: customFilter(),
                filterRenderer: (onFilter) => {
                    return <FormControlLabel
                        control={
                            <Checkbox
                                onChange={e => onFilter(e.target.checked === true ? false : "")}
                                style={{ color: blackColor }}
                            />
                        }
                        label="Exclude Completed"
                        style={{ color: '#32231e', backgroundColor: currentTheme.headerBackground, paddingRight: '10px' }}
                    />;
                }
            },
            {
                dataField: 'Comments',
                text: 'Comments',
                sort: true,
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                },
                style: {
                    color: currentTheme.text
                },
                filter: textFilter({ style: { color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground } })
            },
            {
                dataField: 'df2',
                text: '',
                isDummyField: true,
                headerStyle: {
                    width: '70px',
                    background: currentTheme.headerBackground
                },
                formatter: (cellContent, row) => {
                    return (<div style={{ display: 'flex' }}>
                        <EditIcon style={{ color: currentTheme.secondary }} onClick={() => { editJournal(row); }} />
                        <DeleteIcon style={{ color: currentTheme.secondary }} onClick={() => deleteJournalConfirm(row.AppJournalId)} />
                    </div>
                    );
                }
            }
        ];

        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="journalBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={journalEditOpen} onClose={closeJournalEdit} TransitionComponent={Transition}>
                        <JournalAdd parentCallback={closeJournalEdit}
                            refreshGrid={updateList}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: "95%" }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Typography variant="h6" className={classes.title}>&nbsp;Journal</Typography><StatusIcon />
                                <Grid container justify="flex-end" spacing={2}>
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addJournal}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu moduleName={"Journal"} modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <BootstrapTable bootstrap4 keyField='AppJournalId' data={journals} columns={columns} rowStyle={rowStyle}
                                    hover noDataIndication="No records found" filter={filterFactory()} filterPosition="top" />
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteJournal}
                                    title="Delete Journal" message="Are you sure you want to delete the selected Journal?" />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();

    return (
        <>
            {content}
        </>
    );
}
